import { RoleType } from './user.types';

export const AD_HOC_REPORT_VIEW_ROLES: RoleType[] = [RoleType.Administrator];

export const AD_HOC_REPORT_EDIT_ROLES: RoleType[] = [RoleType.Administrator];

export const AD_HOC_REPORT_MODEL_PICKER_ROLES: RoleType[] = [RoleType.CustomerSupport];
